var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poi-nearby"},[_vm._m(0),_c('div',[_c('POIList',{attrs:{"pois":_vm.nearby,"current-sorting":"DISTANCE_ASC"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar__section sidebar__section--border-top-huge"},[_c('div',{staticClass:"poi-nearby__title caption-light"},[_vm._v("Webcams in der Nähe")])])
}]

export { render, staticRenderFns }